import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "./cn";

const alertVariants = cva("m-0 rounded-md px-3.5 py-2.5 text-[0.92rem]", {
  variants: {
    tone: {
      error: "bg-destructive-soft text-destructive",
      success: "bg-success-soft font-medium text-success",
      warning: "bg-premium-soft text-premium",
      info: "border border-dashed border-border bg-muted text-muted-foreground",
    },
  },
  defaultVariants: { tone: "info" },
});

/** Messages: errors are announced at once (role=alert), others politely (role=status). */
export function Alert({ className, tone, role, ...props }: ComponentProps<"p"> & VariantProps<typeof alertVariants>) {
  return <p role={role ?? (tone === "error" ? "alert" : "status")} className={cn(alertVariants({ tone }), className)} {...props} />;
}
